module.exports = "/images/vendor/flag-icon-css/flags/1x1/mz.svg?e99caf39cbb120f1b498e8b16ccfa3b2";